<template>
  <div class="private-network">
    <p class="df fdc aic">
      <img src="@/assets/img/no_premise.png" alt="专网公文" width="280" />
      <span>{{ tips }}</span>
    </p>

    <p class="private-network__address">{{ PRIVATE_DOMAIN_NAME }}</p>
  </div>
</template>

<script>
import { PRIVATE_DOMAIN_NAME } from '@/promptConfig'

export default {
  name: 'PrivateNetwork',
  props: {
    tips: {
      type: String,
      default: '【专网数据】请到专网查看'
    }
  },

  data() {
    return {
      PRIVATE_DOMAIN_NAME
    }
  }
}
</script>

<style lang="scss" scoped>
.private-network {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 90%;
  padding: 0 20px;

  span {
    margin: 20px 0 0;
    font-size: 15px;
    text-align: center;
    letter-spacing: 1px;
    color: #595959;
  }

  &__address {
    margin: 5px 0 0;
    font-size: 13px;
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrivateNetwork/index.vue